





























































import { Component, Vue, Prop } from 'vue-property-decorator';
import Argurments from '@/components/extrinsics/Arguments.vue';
import Seconds from './Seconds.vue';
import SecondModal from '@/components/shared/modals/Second.vue';
import Identicon from '@polkadot/vue-identicon';
import shortAddress from '@/utils/shortAddress';

@Component({
  components: {
    Argurments,
		Seconds,
		SecondModal,
		Identicon,
  },
})
export default class Proposal extends Vue {
  @Prop() public proposal: any;
  @Prop({ default: 64 }) public size!: number;


  private isArgsVisible: boolean = false;

	get address() {
		return shortAddress(this.proposal.proposer.toString());
	}

  public toggleArgsVisible() {
    this.isArgsVisible = !this.isArgsVisible;
  }

  public handleSelectedArguments() {
    return;
  }

  public enhanceArgs() {
    return this.proposal.proposal.meta.args;
  }
}
